import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { ErrorBoundary } from 'utils/error';
import { useRouteMatch } from 'react-router-dom';

import Sidebar from 'modules/fleet/sidebar';
import FleetFilters from 'modules/fleet/filters';

import { JobReviewProvider } from 'modules/job-review/provider';
import JobReviewFilters from 'modules/job-review/filters';
import JobReviewDetail from 'modules/job-review/detail';

import { JobReviewListEmpty } from 'modules/job-review/list';

const JobReviewListLazy = React.lazy(() => import('modules/job-review/list'));

const t = {
  error: 'Something went wrong',
};

const LoadingFallback = ({ reduced }) => <JobReviewListEmpty reduced={reduced} />;

const ErrorFallback = () => (
  <div className="error-container">
    <div className="error">{t.error}</div>
  </div>
);

const JobReviewSection = ({ className, parentUrl }) => {
  const match = useRouteMatch();
  const matchDetail = useRouteMatch({
    path: `${match.url}/:id`,
  });

  const parentURL = match?.url;
  const reducedListView = !!matchDetail;

  return (
    <JobReviewProvider>
      <div className={className}>
        <FleetFilters appendFilters={<JobReviewFilters />} />
        <div className="section__wrapper">
          <Sidebar parentUrl={parentUrl} section="job-review" />
          <div className="section__content">
            <Suspense fallback={<LoadingFallback reduced={reducedListView} />}>
              <ErrorBoundary fallback={<ErrorFallback />}>
                <JobReviewListLazy parentUrl={parentURL} reduced={reducedListView} />
              </ErrorBoundary>
            </Suspense>
            <Route path={`${match.url}/:id`}>
              <JobReviewDetail parentUrl={parentURL} />
            </Route>
          </div>
        </div>
      </div>
    </JobReviewProvider>
  );
};

export default JobReviewSection;
